let arr=[
    {name:'面积',value:'面积'},
    {name:'数量',value:'数量'},
    {name:'重量',value:'重量'}
]
export default arr